export const mapImageGrid = ({ imageRow }) =>
  imageRow.map((row) =>
    row.imageColumn.map((col) => ({
      src: col?.image?.sourceUrl,
      alt: col?.image?.altText,
    }))
  );
